<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div style="text-align: left;" class="clause">
        <p style="line-height:26pt; margin:0pt 0pt 12pt; text-align:center"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">授权承诺书</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">：</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">您</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">的合法权益，请在点击确认本授权承诺书</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">以下简称</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">“</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">”）</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">前，仔细阅读本授权书全部内容，以知悉</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">您</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">在业务办理中的权利、义务</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">致百望股份有限公司（“贵司”）及贵司关联机构（无锡百商众望数据科技有限公司）：</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">鉴于本人拟通过贵司、关联机构以及下属小望数科平台（以下简称“平台”）推荐，向银行等资金提供方（以下简称“金融机构”）获取贷款以满足本人日常周转之资金需求，就贵司、贵司关联机构及平台采集、处理、使用和对外提供本人个人信息，本人特此做出如下授权和承诺：</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">一、本人特此承诺并确认，本授权书是本人真实的意思表示，本人同意承担由此带来的一切法律后果。本人通过点击或其他方式确认本授权书，即意味着本人明确同意以数据电文形式签署本授权书，认可本授权书的签署方式及效力。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">二、本人同意不可撤销地授权：</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">（一）贵司、贵司关联机构有权采集、处理</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">的</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">基本信息（姓名、身份证号、手机号），用于本人的身份认证、资质评估、风险控制等；</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">（二）</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">贵司</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">、贵司</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">有权根据本人的委托向金融机构提供本人的基本信息（姓名、身份证号、手机号等），用于本人向金融机构申请金融服务；</span>
        </p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">（三）</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">金融机构有权向贵司、贵司关联机构，进而贵司、贵司关联机构有权向推荐本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人使用</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">贵司、关联机构</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">产品的第三方主体（即</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人所知悉的、提供给</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人邀请码的主体）</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">，提供本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">在该等金融机构产生的贷款业务相关数据字段（以具体金融机构政策为准），包括但不限于订单基本信息类（如订单ID）、授信信息类（如授信金额、授信时间、可用额度、年化利率、额度生效/失效日、额度状态、拒绝原因）、提款信息类（如放款金额、放款时间、借款期限、放款状态、年化利率、提款ID、还款状态）、还款信息类（如还款方式、还款期数、还款状态、应还日期、应还总金额、应还本金、应还利息、应还罚息、应还复利、待还总金额、待还本金、待还利息、待还罚息、待还复利），</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">该等第三方主体可以在平台内查阅脱敏后信息，</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">以便</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">其</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">进行结算。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">（五）贵司、关联机构及平台如需向境外传输本人的基本信息，应取得本人的特别授权。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">三、本人对自身提供的所有信息的真实性、完整性、准确性承担全部责任。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">四、本人承诺，在使用平台服务过程中实施的所有行为均遵守国家法律、法规及平台的各项规则，不违背社会公共利益或公共道德，不损害他人的合法权益，不对平台上的任何数据作商业性利用，包括但不限于在未经贵司及关联机构事先书面同意的情况下，以复制、传播等任何方式使用平台上展示的资料。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">五、本人知悉并确认，贵司、关联机构及平台提供服务过程中涉及的所有内容</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">(</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">包括但不限于网页、文字、图片、音频、视频、图表等</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">)</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">的知识产权归贵司、关联机构及平台所有。除另有特别声明外，贵司、关联机构及平台提供相关服务时所依托软件的著作权、专利权及其他知识产权均归贵司、关联机构及平台所有。</span>
        </p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">六、</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">知悉并确认，贵司</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构及平台有权根据需要适时修改本授权书及</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">/</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">或其他各类规则，并在平台上公示。本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">同意，如继续使用平台服务并就更新后的版本重新点击确认，即表示本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">理解并接受新修订的授权书和规则。</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">七、</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">无条件、不可撤销地承诺，当本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">的行为涉嫌违反法律法规或违反本授权书及</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">/</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">或平台相关规则的，贵司</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构及平台有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息，或直接停止提供服务。如本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">的行为使贵司及关联机构及下属平台遭受任何损失</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">(</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">包括但不限于受到第三方的索赔、受到行政管理部门的处罚等</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">)</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">，本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">还应当赔偿或补偿贵司</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构及平台遭受的全部损失及发生的全部费用，包括但不限于诉讼费、律师费、保全费等。 </span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">八、本人自愿接收贵司、贵司关联机构及平台，以及与贵司、贵司关联机构合作的金融机构向本人提供的持续短信通知服务</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">(</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">通知的信息包括但不限于验证码信息、贷款结果相关的信息</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">)</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">。如对本人的日常工作造成影响，本人可自行通过短信方式取消订阅。</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal"> </span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">九、本人了解贵司、贵司关联机构及平台的信息异议和投诉处理规定，同意贵司、贵司关联机构及平台自收到本人异议后对相关信息做出存在异议的标注，并自收到异议请求之日起</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">20</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">日内进行核查和处理，同时将结果书面答复本人。如贵司、关联机构及平台侵害本人的合法权益，本人有权通过向相关主管部门及其派出机构进行投诉或直接向人民法院起诉的方式进行维权。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">十、本授权书之解释权归属于百望股份有限公司及其关联机构。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">十一、本授权书自本人在平台上点击确认之日起生效，至本人与贵司、贵司关联机构及</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">/</span><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">或金融机构的业务关系结束之日终止。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
            style="font-family:宋体; font-size:11pt; font-weight:normal">本人于平台点击确认本授权书具有下述含义：</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">本人的点击系代表本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">对于本授权书的正式签署。本授权书项下授权、承诺的行为完全是由本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">独立、自主、谨慎做出。本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">已仔细阅读上述所有条款，并已特别注意字体加黑的内容。</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">贵司</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">已应本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">要求对相关条款予以明确解释说明。本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">对所有条款的含义及相应的法律后果</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">，均</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">已全部通晓并充分理解。本</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">自愿作出上述授权、承诺和声明</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">。</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">授权</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">(</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">姓名</span><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">)</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">：{{fillData.borrowerName}}</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">授权人身份证号：{{fillData.borrowerIdentity}}</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">授权</span><span
            style="font-family:宋体; font-size:11pt; font-weight:bold">日期：{{date}}</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
            style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">&nbsp;</span></p>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'FeildTwo',
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
    };
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  inject: {
    root: {
      default: null
    },
    bindUserRoot: {
      default: null
    }
  },
  computed: {
    fillData(){
      if(this.root)
      return this.root.fapi.getState()
      return null
    }
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
